import { createMuiTheme } from '@material-ui/core/styles';
import globalThemeOptions from '@/themes/globalThemeOptions';
import palette from '@/themes/palette';

export const getTheme = (colorTheme) => createMuiTheme({
  ...globalThemeOptions,
  palette: palette({ accentColor: colorTheme })
});
